import {RouteConfig} from 'vue-router';
import TeamMembers from '@/components/Challenges/tabs/teams/members/TeamMembers.vue';
import ChallengeTeamForm from '@/components/Challenges/tabs/teams/ChallengeTeamForm.vue';
import TeamInvitation from '@/components/Challenges/tabs/teams/invites/TeamInvitation.vue';
import TeamPendentInvitations from '@/components/Challenges/tabs/teams/invites/TeamPendentInvitations.vue';

export const teamRoutes: RouteConfig[] = [
  {
    path: 'members',
    name: 'challenge-team-members',
    component: TeamMembers,
  },
  {
    path: 'edit',
    name: 'edit-challenge-team',
    component: ChallengeTeamForm,
  },
  {
    path: 'invite',
    name: 'invite-user-to-team',
    component: TeamInvitation,
  },
  {
    path: 'pendent',
    name: 'team-invitations-pendent',
    component: TeamPendentInvitations,
  },
];
